import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import CustomTable from "../../utils/commonComponent/CustomAntTable";
import { ComponentHeader, InformationModal, VerifiedModal } from '../common';
import { getAllCalenderApi, getAllCalenderFilterApi } from './Api';
import editIcon from '../../assets/images/edit-icon.svg'
import deleteIcon from '../../assets/images/delete-icon.svg'
import { Button, Col, Image, Row } from "react-bootstrap";
import { API_LIMIT, MODULE_ID_MAP, START_PAGE, isModuleExist } from "../../utils/Constant";
import editPencil from "../../assets/images/edit-icon.png";
import { CALENDER_FILTER_VERIFY, CALENDER_VERIFY, SSO_VERIFY, SUBDOMAIN_VERIFY, USER_ROLE_VERIFY } from '../../utils/urls';
import FilterVefiedDropDown from '../common/FilterVefiedDropDown';
import { deleteAuthCommonApi } from "../content/Api";
import { toast } from 'react-toastify';
import { withRouter } from '../../utils/hoc/withRouter';
import OptionsDropdown from '../../utils/commonComponent/OptionsDropdown';
import { Tag } from 'antd';



class CalenderFilter extends Component {
  constructor(props) {
    super(props);
    const AccesData = isModuleExist(MODULE_ID_MAP.SubDomainCalendarFilter);

    this.state = {
      access: AccesData,
      delete: false,
      deleteData: {},
      editData: "",
      showEdit: false,
      isVerify: false,
      show: false,
      verified: '',
      verifyUrl: ''
    }
  }

  componentDidMount() {
    const { history } = this.props;
    history({
      pathname: this.props.location.pathname,
      search: `?p=${this.state.currentPage || START_PAGE}`,
    });
    this.props.getAllCalenderFilterApi(this);
  }
  componentDidUpdate(prevProps, prevState) {
    const prevParams = new URLSearchParams(prevProps.location.search);
    const prevPage = parseInt(prevParams.get("page"), 10) || START_PAGE;
    const prevVerified = prevParams.get("isVerified") || "";

    const params = new URLSearchParams(this.props.location.search);
    const page = parseInt(params.get("page"), 10) || START_PAGE;
    const verified = params.get("isVerified") || "";



    if (prevPage !== page || prevVerified !== verified) {
      this.setState({ currentPage: page }, () => {
        this.props.getAllCalenderFilterApi(this);

      });
    }
  }
  // getDetailsCalender = (data) => {
  //     this.props.history({ pathname: `/calender-filter/details/${data?.uuid}`, state: { "data": data } });
  // }

  showEditModal = (rowData = null) => {
    this.props.history({ pathname: `/subdomain/edit-filter`, state: { "data": rowData, "id": rowData.uuid } })
    this.setState({
      showEdit: !this.state.showEdit,
      editData: rowData
    });
  };
  openCloseDeleteModal = (rowData) => {
    this.setState({
      delete: !this.state.delete,
      deleteData: rowData,
    });
  };
  deleteHandle = async (id) => {
    const res = await deleteAuthCommonApi(`/calender-filter/${id}`);
    // console.log(res)
    if (res.status === 200) {
      this.props.getAllCalenderFilterApi(this);
      this.setState({
        delete: !this.state.delete
      });

    } else {
      toast.error("Somthis wrong...")
    }
  }

  render() {
    const { access } = this.state;

    const { calenderFilterList, totalPages, currentPage } = this.props.subdomainState;

    return (
      <>

        {this.state.delete && (
          <InformationModal
            show={this.state.delete}
            id={this.state.deleteData?.uuid}
            title={`Are you sure you want to delete ${this.state.deleteData?.filterName} ?`}
            handleClose={this.openCloseDeleteModal}
            handleDelete={this.deleteHandle}
          />
        )}
        <VerifiedModal
          // name={`this '${this.state.editData?.campaignName}' campaign.`}
          name={`'${this.state.editData?.filterName}'`}
          show={this.state.show}
          url={CALENDER_FILTER_VERIFY + `/${this.state?.editData?.uuid}`}
          isVerified={this.state.isVerify}
          handleCancel={() => { this.setState({ show: false }) }}
          successRes={() => { this.props.getAllCalenderFilterApi(this) }}
        />
        <section className="request-section">
          <ComponentHeader
            title="Calendar Filters"
            isSearch={false}
            // placeholder={"Search User"}
            // onChangeMethod={this.onChangeMethod}
            // clearSearch={() => this.clearSearch()}
            primaryBtn={access.createAccess ? "Add Filter" : ""}
            handlePrimaryBtn={() => {
              this.props.history({ pathname: "/subdomain/add-filter", state: { calenderFilterList } });
            }}
            ctx={this}
          />
          <Row>
            <Col sm={2}>
              <FilterVefiedDropDown ctx={this} />
            </Col>
          </Row>
          <div className="commom-table-wrapper">
            <CustomTable
              data={calenderFilterList?.list || []}
              columns={[
                {
                  width: 180,
                  title: "Filter Name",
                  dataIndex: "filterName",
                  className: "name",
                  render:(text, rowData, dataKey) => {
                      return rowData?.filterName;
                  },
                },
                {
                  width: access.verificationAccess ? 110 : 0,
                  title: "Verified",
                  dataIndex: "isVerified",
                  className: "verify",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                     const color = rowData.isVerified ? 'green' : 'orange';

                    return <div className=" d-flex align-items-center inter-medium">
                      <Tag color={color}>{rowData.isVerified ? "YES" : "NO"}
                        <Image src={editPencil} onClick={() => this.setState({ show: true, isVerify: rowData.isVerified, editData: rowData })} className="edit-pencil-icon" alt="icon" />
                      </Tag>
                    </div>;
                  },
                },
                {
                  width: 150,
                  title: "Icon",
                  dataIndex: "icon",
                  className: "icon",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                      return <Image className="table-img" src={rowData?.icon} alt="icon" />;

                  },
                },

                {
                  width: 130,
                  title: "Code",
                  dataIndex: "code",
                  className: "code",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                      return rowData?.code || 'Na';
                  },
                },

                {
                  width: 20,
                  title: "Action",
                  dataIndex: "",
                  className: "",
                  isCell: true,
                  render:(text, rowData, dataKey) => {
                      return (


                        // <>
                        //   {/* <Button onClick={() => this.getDetailsCalender(rowData)} className=" primary-btn mr-4">
                        //                                 View Detail
                        //                             </Button> */}

                        //   {access.updateAccess && (
                        //     <Image src={editIcon} className="edit-icon" onClick={() => { this.showEditModal(rowData) }} />
                        //   )}
                        //   {access.deleteAccess && (
                        //     <Image src={deleteIcon} className="edit-icon" onClick={() => { this.openCloseDeleteModal(rowData) }} />
                        //   )}
                        // </>
                        <OptionsDropdown
                          editHandler={access.updateAccess ? () => { this.showEditModal(rowData) } : null}
                          deleteHandler={access.deleteAccess ? () => { this.openCloseDeleteModal(rowData) } : null}
                        />

                      );
                  },
                },
              ]}
              message="No data found" // For Pagination
              history={this.props.history}
              location={this.props.location}
              total={totalPages}
              currentPage={currentPage}
              loading={this.state.isLoading}
            />
          </div>
        </section>
      </>
    )
  }
}

const mapStateToProps = state => ({
  subdomainState: state.SubdomainState
});
const mapDispatchToProps = {
  getAllCalenderFilterApi,
}
CalenderFilter.propTypes = {
  // getPosts: PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CalenderFilter));